export default {
      id: "Group2-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Group2",
      toString: function () {
        return this.url;
      }
    }